const LOCALSTORAGE_KEY = 'vhccr_data';

const getItem = (key: string): any => {
  return JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}_${key}`));
};

const saveItem = (key: string, value: any) => {
  try {
    localStorage.setItem(`${LOCALSTORAGE_KEY}_${key}`, JSON.stringify(value));
  } catch (error) {
    localStorage.removeItem(`${LOCALSTORAGE_KEY}_${key}`);
  }
};

const deleteItem = (key: string) => {
  localStorage.removeItem(`${LOCALSTORAGE_KEY}_${key}`);
};

export function useLocalStorage() {
  return {
    getItem,
    saveItem,
    deleteItem,
  };
}
